const alignAndEngageRoutes = {
  AlignAndEngage: () => `/align-and-engage`,
  AlignAndEngageOverview: () => `/align-and-engage/overview`,
};

const routes = { ...alignAndEngageRoutes };

export default routes;
